import React, { useState, useCallback, CSSProperties } from "react";
import { useData } from "../../context/DataProvider";
import { useAnalytics } from '@popped/popshap-kiosk-components';
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CustomSlider from "../CustomSlider";
import Toggle from "../Toggle";


import "./index.scss"

const Slideshow = ({ slides, title, setCurrentSlideshow }: { slides: any[], title: string, setCurrentSlideshow: (slideshow: any) => void }) => {


    const { logEvent } = useAnalytics();
    const { config } = useData()!
    //const { button, card } = useParams()
    const navigate = useNavigate()
    //const [currentButton, setCurrentButton] = useState<any>(null);

    //const timeoutCallback = () => navigate("/");
    const [currentItem, setCurrentItem] = useState(0);
    const _logEvent = useCallback(async (type: string, value: string) => {
        await logEvent(type, value, { kiosk: 'kiosk-2023' })
    }, [logEvent])

    const arrowStyles: CSSProperties = {
        position: 'absolute',
        zIndex: 2,
        top: 'calc(50% - 54px)',
        width: 108,
        height: 108,
        cursor: 'pointer',
        background: "none",
        border: "none",
        outline: "none",
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat"

    };

    return (
        <div className="slideshowComponent page" key={title}>
            {/* <img onClick={() => navigate(`/${button}`)} src={`https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/geocomply/assets/slides/${button}/${card}/Breadcrumbs.svg`} alt="" className="breadcrumbs" /> */}

            <div className="breadcrumbs" onClick={() => setCurrentSlideshow(null)}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.9998 7.33341L3.33317 16.0001M3.33317 16.0001L11.9998 24.6667M3.33317 16.0001L28.6665 16.0001" stroke="#FF600F" stroke-width="3" stroke-linecap="square" />
                </svg>
                <p>{title}</p>
            </div>
            <div className="home" onClick={() => setCurrentSlideshow(null)}>
                <svg width="133" height="89" viewBox="0 0 133 89" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="132.443" height="88.4992" rx="44.2496" fill="#0A003C" />
                    <path d="M61.5488 57.125V50.2742C61.5488 47.7509 63.5927 45.707 66.116 45.707C68.6393 45.707 70.6832 47.7509 70.6832 50.2742V57.125" stroke="#FF600F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M53.5566 54.8404V42.2806L66.1165 32L78.6763 42.2762V54.836C78.6763 56.0998 77.6521 57.1196 76.3927 57.1196H55.8402C54.5764 57.1196 53.5566 56.0955 53.5566 54.836V54.8404Z" stroke="#FF600F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>

            <Carousel
                showArrows={true}
                infiniteLoop={false}
                centerMode={true}
                centerSlidePercentage={90}
                onChange={setCurrentItem}
                //autoPlay={true}
                //interval={5000}
                className={currentItem === 0 ? "first" : currentItem === slides.length - 1 ? "last" : ""}
                renderArrowPrev={(onClickHandler, hasPrev, label) =>
                    hasPrev && (
                        <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, left: 15, }}>
                            <svg width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Group 2">
                                    <circle id="Ellipse 5" cx="54" cy="54" r="53" fill="#F4F7FA" stroke="#0A003C" stroke-width="2" />
                                    <path id="Line 1" d="M31.9393 52.9393C31.3536 53.5251 31.3536 54.4749 31.9393 55.0607L41.4853 64.6066C42.0711 65.1924 43.0208 65.1924 43.6066 64.6066C44.1924 64.0208 44.1924 63.0711 43.6066 62.4853L35.1213 54L43.6066 45.5147C44.1924 44.9289 44.1924 43.9792 43.6066 43.3934C43.0208 42.8076 42.0711 42.8076 41.4853 43.3934L31.9393 52.9393ZM74 55.5C74.8284 55.5 75.5 54.8284 75.5 54C75.5 53.1716 74.8284 52.5 74 52.5V55.5ZM33 55.5H74V52.5H33V55.5Z" fill="#0A003C" />
                                </g>
                            </svg>

                        </button>
                    )
                }
                renderArrowNext={(onClickHandler, hasNext, label) =>
                    hasNext && (
                        <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, right: 15, }}>
                            <svg width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Arrow">
                                    <g id="Group 1">
                                        <circle id="Ellipse 5" cx="54" cy="54" r="53" fill="#F4F7FA" stroke="#0A003C" stroke-width="2" />
                                        <path id="Line 1" d="M33 52.5C32.1716 52.5 31.5 53.1716 31.5 54C31.5 54.8284 32.1716 55.5 33 55.5V52.5ZM75.0607 55.0607C75.6464 54.4749 75.6464 53.5251 75.0607 52.9393L65.5147 43.3934C64.9289 42.8076 63.9792 42.8076 63.3934 43.3934C62.8076 43.9792 62.8076 44.9289 63.3934 45.5147L71.8787 54L63.3934 62.4853C62.8076 63.0711 62.8076 64.0208 63.3934 64.6066C63.9792 65.1924 64.9289 65.1924 65.5147 64.6066L75.0607 55.0607ZM33 55.5H74V52.5H33V55.5Z" fill="#0A003C" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    )
                }>

                {
                    slides.map((slide: any, index: number) => {
                        const style: any = {};
                        // if (index === 0)
                        //     style.margin = '0px 40px 0px 80px';
                        // else if (index === slides.length - 1)
                        //     style.margin = '0px 80px 0px 40px';
                        // else
                        //     style.margin = '0px 40px';

                        return (
                            <React.Fragment key={`${title}_${index}`}>
                                {
                                    index === 0 ?
                                        <Touch />
                                        : <></>
                                }
                                {
                                    slide.type === "image" ?
                                        <img src={slide.url} style={style} alt={``} />
                                        : <></>
                                }
                                {
                                    slide.type === "video" ?

                                        <Video slide={slide} style={style} play={currentItem === index} loop={true} />
                                        : <></>
                                }
                                {
                                    slide.type === "slideshow" ?
                                        <InnerSlideshow slides={slide.slides} style={style} />
                                        : <></>
                                }
                                {
                                    slide.type === "svg" ?
                                        slide.svg
                                        : <></>
                                }
                                {
                                    slide.type === "customSlider" ?
                                        <CustomSlider />
                                        : <></>
                                }
                                {
                                    slide.type === "toggle" ?
                                        <>
                                            <ToggleSlide url1={slide.url1} url2={slide.url2} />
                                        </> : <></>
                                }
                            </React.Fragment>
                        )
                    })

                }
            </Carousel>
        </div>
    )
}

export default Slideshow;


const ToggleSlide = ({ url1, url2 }: { url1: string, url2: string }) => {

    const [toggle, setToggle] = useState(false);

    return (
        <div className={`toggleSlide ${toggle ? "toggled" : ""}`}>
            <img className={"first"} src={url1} alt="" />
            <img className={"second"} src={url2} alt="" />

            <Toggle value={toggle} onChange={setToggle} />
        </div>
    )
}


const Video = ({ slide, play, reset, loop, style }: { slide: any, play: boolean, loop: boolean, reset?: boolean, style?: React.CSSProperties, }) => {
    const videoRef = React.useRef<HTMLVideoElement>(null);

    React.useEffect(() => {
        if (videoRef.current) {
            if (play) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    }, [play]);
    React.useEffect(() => {
        if (videoRef.current) {
            if (reset) {
                videoRef.current.currentTime = 0;
            }
        }
    }, [reset]);
    return (
        <div style={style} className={play ? " video play" : " video hide"}>
            {slide.underlay ? <div className="layer">
                <img src={slide.underlay} alt="" />
            </div> : <>   </>}
            <div className="layer">
                <video

                    loop={loop}
                    ref={videoRef}
                    src={slide.url}
                    style={slide.videoStyle ?? {}}

                    muted
                />
            </div>
            {slide.overlay ? <div className="layer">
                <img src={slide.overlay} alt="" />
            </div> : <></>}
        </div>


    )

}


const Touch = () => (
    <div className="touch">
        <svg width="230" height="230" viewBox="0 0 230 230" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.8" cx="115" cy="115" r="113.647" fill="#F4F7FA" stroke="#0041ED" stroke-width="2.70588" />

        </svg>
        <svg width="200" height="185" viewBox="0 0 306 313" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M66 31.5C64.6193 31.5 63.5 32.6193 63.5 34C63.5 35.3807 64.6193 36.5 66 36.5V31.5ZM198.768 35.7678C199.744 34.7915 199.744 33.2085 198.768 32.2322L182.858 16.3223C181.882 15.346 180.299 15.346 179.322 16.3223C178.346 17.2986 178.346 18.8816 179.322 19.8579L193.464 34L179.322 48.1421C178.346 49.1184 178.346 50.7014 179.322 51.6777C180.299 52.654 181.882 52.654 182.858 51.6777L198.768 35.7678ZM66 36.5H197V31.5H66V36.5Z" fill="#0041ED" />
            <path d="M20.2322 88.2322C19.2559 89.2085 19.2559 90.7915 20.2322 91.7678L36.1421 107.678C37.1184 108.654 38.7014 108.654 39.6777 107.678C40.654 106.701 40.654 105.118 39.6777 104.142L25.5355 90L39.6777 75.8579C40.654 74.8816 40.654 73.2986 39.6777 72.3223C38.7014 71.346 37.1184 71.346 36.1421 72.3223L20.2322 88.2322ZM153 92.5C154.381 92.5 155.5 91.3807 155.5 90C155.5 88.6193 154.381 87.5 153 87.5V92.5ZM22 92.5H153V87.5H22V92.5Z" fill="#0041ED" />
            <path className={"hand"} d="M219.431 173.873L219.424 173.87L219.431 173.873ZM215.124 185.702L229.286 146.741C231.636 140.277 238.781 136.942 245.245 139.292C252.494 141.926 256.234 149.94 253.599 157.19L239.955 194.728M239.955 194.728L246.982 175.394C249.475 168.537 256.289 167.104 263.146 169.596C270.003 172.089 273.54 179.668 271.048 186.525L264.785 203.754L251.938 239.089C242.799 264.233 229.111 278.217 229.111 278.217L218.078 308.579L161.798 288.119L129.953 276.547L140.994 246.188C129.204 230.456 123.589 210.938 125.216 191.347L128.615 150.474C128.681 149.627 128.863 148.813 129.143 148.043C130.494 144.322 134.126 141.743 138.266 141.874C151.558 142.295 161.889 153.599 161.119 166.877L160.236 182.042L165.463 167.65L181.102 124.384L190.379 99.1059L196.701 81.7148C199.051 75.2506 206.908 72.1743 213.372 74.5241C220.622 77.1588 223.649 84.9132 221.014 92.1624L214.954 108.836L205.806 133.758L190.294 176.676M190.294 176.676L211.322 118.663L227.024 75.3456C229.516 68.4885 237.095 64.9511 243.952 67.4435C250.809 69.9359 254.347 77.5147 251.854 84.3718L234.254 132.927L215.124 185.702" fill="#F4F7FA" />
            <path className={"hand"} d="M219.431 173.873L219.424 173.87M215.124 185.702L229.286 146.741C231.636 140.277 238.781 136.942 245.245 139.292C252.494 141.926 256.234 149.94 253.599 157.19L239.955 194.728L246.982 175.394C249.475 168.537 256.289 167.104 263.146 169.596C270.003 172.089 273.54 179.668 271.048 186.525L264.785 203.754L251.938 239.09C242.8 264.233 229.111 278.217 229.111 278.217L218.078 308.579L161.798 288.119L129.953 276.547L140.994 246.188C129.204 230.456 123.589 210.938 125.216 191.347L128.615 150.474C128.681 149.627 128.863 148.813 129.143 148.043C130.494 144.322 134.126 141.743 138.266 141.874C151.558 142.295 161.889 153.599 161.119 166.877L160.236 182.042L165.463 167.65L181.102 124.384L190.379 99.1059L196.701 81.7148C199.051 75.2506 206.908 72.1743 213.372 74.5241C220.622 77.1588 223.649 84.9132 221.014 92.1624L214.954 108.836L205.806 133.758L190.294 176.676L211.322 118.663L227.024 75.3456C229.516 68.4885 237.095 64.9511 243.952 67.4435C250.809 69.9359 254.347 77.5147 251.854 84.3718L234.254 132.927L215.124 185.702Z" stroke="#0A003C" stroke-width="7.224" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
)

const InnerSlideshow = ({ slides, style }: { slides: any, style: React.CSSProperties }) => {

    const [currentSlide, setCurrentSlide] = useState(0);

    return (
        <div className="innerSlideshow" style={style}>
            {
                slides.map((slide: any, index: number) => (

                    <Video key={index} slide={slide} play={currentSlide === index} reset={currentSlide !== index} loop={false} />


                ))
            }

            <svg width="632" height="70" viewBox="0 0 632 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="34.75" cy="34.75" r="33.25" stroke="#FF600F" stroke-width="3" fill="#00000000" onClick={() => setCurrentSlide(0)} />
                {
                    currentSlide > 0 ?
                        (
                            <>
                                <rect x="69.5" y="33.25" width="118" height="3" fill="#FF600F" />
                                <circle cx="222.25" cy="34.75" r="33.25" stroke="#FF600F" stroke-width="3" fill="#00000000" onClick={() => setCurrentSlide(1)} />
                            </>
                        ) :
                        (<>
                            <g opacity="0.5">
                                <rect x="69.5" y="33.25" width="118" height="3" fill="#DFE3E8" />
                            </g>
                            <g opacity="0.5">
                                <circle cx="222.25" cy="34.75" r="34.75" fill="#DFE3E8" onClick={() => setCurrentSlide(1)} />
                            </g>
                        </>)
                }

                {
                    currentSlide > 1 ?
                        (
                            <>
                                <rect x="257" y="33.25" width="118" height="3" fill="#FF600F" />
                                <circle cx="409.75" cy="34.75" r="33.25" stroke="#FF600F" stroke-width="3" fill="#00000000" onClick={() => setCurrentSlide(2)} />
                            </>
                        ) :
                        (<>
                            <g opacity="0.5">
                                <rect x="257" y="33.25" width="118" height="3" fill="#DFE3E8" />
                            </g>
                            <g opacity="0.5">
                                <circle cx="409.75" cy="34.75" r="34.75" fill="#DFE3E8" onClick={() => setCurrentSlide(2)} />
                            </g>
                        </>)
                }
                {
                    currentSlide > 2 ?
                        (
                            <>
                                <rect x="444.5" y="33.25" width="118" height="3" fill="#FF600F" />
                                <circle cx="597.25" cy="34.75" r="33.25" stroke="#FF600F" stroke-width="3" fill="#00000000" onClick={() => setCurrentSlide(3)} />
                            </>
                        ) :
                        (<>
                            <g opacity="0.5">
                                <rect x="444.5" y="33.25" width="118" height="3" fill="#DFE3E8" />
                            </g>
                            <g opacity="0.5">
                                <circle cx="597.25" cy="34.75" r="34.75" fill="#DFE3E8" onClick={() => setCurrentSlide(3)} />
                            </g>
                        </>)
                }
            </svg>
        </div>

    )
}